(() => {
  const shuffle = items => {
    const result = items.slice();
    for (let i = result.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [result[i], result[j]] = [result[j], result[i]];
    }
    return result;
  };

  async function loadPool(url) {
    const cards = new Map();
    const visited = new Set();
    let next = new URL(url, location.origin);
    while (next) {
      if (next.origin !== location.origin || visited.has(next.href)) throw new Error('Invalid bestseller pagination');
      visited.add(next.href);
      next.searchParams.set('section_id', 'bv-bestseller-pool');
      const response = await fetch(next, { credentials: 'same-origin', signal: AbortSignal.timeout(20000) });
      if (!response.ok) throw new Error('Bestseller pool unavailable');
      const document = new DOMParser().parseFromString(await response.text(), 'text/html');
      const pool = document.querySelector('[data-bv-pool]');
      if (!pool) throw new Error('Bestseller pool missing');
      pool.querySelectorAll('template[data-bv-product]').forEach(card => cards.set(card.dataset.bvProduct, card));
      next = pool.dataset.next ? new URL(pool.dataset.next, location.origin) : null;
    }
    return [...cards.values()];
  }

  function initialize(root) {
    if (root.dataset.bvInitialized) return;
    root.dataset.bvInitialized = 'true';
    const count = Number(root.dataset.bvCount) || 10;
    const pools = new Map();
    const panels = [...root.querySelectorAll('.collection-tabs_panel')];
    const buttons = [...root.querySelectorAll('button[data-collection-url]')];
    const buttonFor = panel => buttons.find(button => button.getAttribute('aria-controls') === panel.id);
    const filteredUrl = button => {
      const url = new URL(button.dataset.collectionUrl, location.origin);
      url.pathname = url.pathname.replace(/\/$/, '') + '/' + encodeURIComponent('бестселлер');
      return url;
    };

    async function update(panel) {
      if (!panel || panel.dataset.bvLoaded || panel.dataset.bvLoading) return;
      const button = buttonFor(panel);
      const grid = panel.querySelector('.grid');
      if (!button || !grid) return;
      panel.dataset.bvLoading = 'true';
      panel.setAttribute('aria-busy', 'true');
      try {
        const url = filteredUrl(button);
        if (!pools.has(url.href)) pools.set(url.href, loadPool(url).catch(error => { pools.delete(url.href); throw error; }));
        const cards = await pools.get(url.href);
        const chosen = shuffle(cards).slice(0, count);
        const fragment = document.createDocumentFragment();
        for (const template of chosen) {
          const content = template.content.cloneNode(true);
          content.querySelectorAll('[id]').forEach(node => {
            const oldId = node.id;
            const newId = `${oldId}-${panel.id}`;
            node.id = newId;
            content.querySelectorAll('[for], [aria-controls], [form]').forEach(reference => {
              for (const attribute of ['for', 'aria-controls', 'form']) {
                if (reference.getAttribute(attribute) === oldId) reference.setAttribute(attribute, newId);
              }
            });
          });
          fragment.append(content);
        }
        grid.replaceChildren(fragment);
        panel.dataset.bvLoaded = 'true';
        panel.dataset.bvPoolSize = String(cards.length);
        panel.querySelector('css-slider')?.resetSlider();
      } catch (error) {
        console.warn('Bestseller rotation:', error.message);
      } finally {
        delete panel.dataset.bvLoading;
        panel.removeAttribute('aria-busy');
      }
    }

    root.addEventListener('click', event => {
      const button = event.target.closest('button[data-collection-url]');
      if (button) update(panels.find(panel => panel.id === button.getAttribute('aria-controls')));
    });
    const start = () => update(panels.find(panel => panel.classList.contains('active')) || panels[0]);
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); start(); }
      }, { rootMargin: '400px' });
      observer.observe(root);
    } else start();
  }

  const mount = () => document.querySelectorAll('[data-bv-rotation]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
  document.addEventListener('shopify:section:load', mount);
})();
